import React from 'react';
import tw from 'twin.macro';
import { useTableContext } from './index';

interface Props {
  children?: React.ReactNode;
  className?: string;
  colSpan?: number;
  wrap?: boolean;
}

export default function Td(props: Props) {
  const { children, className, wrap = false, ...rest } = props;
  const { condensed } = useTableContext();

  return (
    <td
      className={className}
      css={[
        tw`text-sm text-neutral-intense`,
        condensed ? tw`px-3 py-2` : tw`px-6 py-4`,
        !wrap && tw`whitespace-nowrap`,
      ]}
      {...rest}
    >
      {children}
    </td>
  );
}
